//筛选条件下拉
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import { Dropdown, Menu, Checkbox } from "antd";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data = [], callback, type, className, props = {} }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const keyLabelObj = useMemo(() => {
    return {
      displayAvailableOnly: t("finance.displayAvailableOnly"),
      matchMyAssets: t("finance.matchMyAssets"),
      sortByApy: t("finance.sortByApy"),
      myStakedPoolsOnly: t("finance.myStakedPoolsOnly"),
    };
  }, []);
  const btnLabel = useMemo(() => {
    if (!data.length) return t("finance.selectFilter");
    return t("finance.filterSelected", [data.length]);
  }, [data]);

  const handleChange = (key, isChecked) => {
    const newData = [...data];
    if (isChecked) {
      if (!newData.includes(key)) newData.push(key);
    } else {
      const index = newData.findIndex((str) => str === key);
      if (index >= 0) newData.splice(index, 1);
    }
    callback && callback(newData);
  };

  return (
    <Dropdown
      overlay={
        <Menu
          items={[
            {
              key: "displayAvailableOnly",
              label: (
                <Checkbox checked={data.includes("displayAvailableOnly")} onChange={(e) => handleChange("displayAvailableOnly", e.target.checked)}>
                  {keyLabelObj.displayAvailableOnly}
                </Checkbox>
              ),
            },
            {
              key: "matchMyAssets",
              label: (
                <Checkbox checked={data.includes("matchMyAssets")} onChange={(e) => handleChange("matchMyAssets", e.target.checked)}>
                  {keyLabelObj.matchMyAssets}
                </Checkbox>
              ),
            },
            type === "Launchpool" ? {
              key: "myStakedPoolsOnly",
              label: (
                <Checkbox checked={data.includes("myStakedPoolsOnly")} onChange={(e) => handleChange("myStakedPoolsOnly", e.target.checked)}>
                  {keyLabelObj.myStakedPoolsOnly}
                </Checkbox>
              ),
            } : {
              key: "sortByApy",
              label: (
                  <Checkbox checked={data.includes("sortByApy")} onChange={(e) => handleChange("sortByApy", e.target.checked)}>
                    {keyLabelObj.sortByApy}
                  </Checkbox>
              ),
            },
          ]}
        ></Menu>
      }
      {...props}
    >
      <button className={cx("btntxt", styles.trigger, className)}>{btnLabel}</button>
    </Dropdown>
  );
});
